import React, { useCallback, useEffect, useState } from "react";
import MdaeMenu from "../menu";
import { isEqual } from "lodash";
import $ from "jquery";
import { actions, callOperation } from "async-ops";
import { useDispatch, useSelector } from "react-redux";
import MdaeDrawerListItemMenuTemplate from "./mdae-drawer-menu-list-item-submenu-template";
import { GET_EMDR_UNSEEN_DOC_COUNT } from "../../../pages/emdr-inbox/inbox/services/get-emdr-unseen-doc-count";
import Notification from "../bubble-notification/notification"
import { bindActionCreators } from "redux";
import { SET_EMDR_UNSEEN_DOC_COUNT } from "./reducers/mdae-navigation-bar-reducer";
import { updateCount } from "../../../pages/emdr-inbox/inbox/component";
const MdaeDrawerListItemTemplate: React.FC<any> = (props) => {

  const isMdaeNavigationBarExpanded = useSelector(
    (state) => state["mdaeNavigationBarReducer"].isMdaeNavigationBarExpanded,
    isEqual
  );
const currentItemNotificationCount = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.notificationCounts?.find(x => x.name === props.auditsSectionMenuItemListItem.title)?.count
  ); 
  const dispatch = useDispatch();

  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  ); 

  useEffect(() => {
    if (props.auditsSectionMenuItemListItem.title === 'eMDR Inbox') {
      updateCount(dispatch) // Call the API to fetch the count
    }
  },[]);

  return (
    <div
      style={{
        height: "100%",
        width: isMdaeNavigationBarExpanded ? "250px" : "80px",
      }}
    >
      {props.auditsSectionMenuItemListItem.menuSectionTitle &&
        isMdaeNavigationBarExpanded && (
          <div className="mdae-menu-item-section audits-tab-section">
            {props.auditsSectionMenuItemListItem.menuSectionTitle}
          </div>
        )}
      <div
        style={{
          padding:
            !isMdaeNavigationBarExpanded &&
            props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
              props.auditsSectionMenuItemListItem
            )
              ? "10px"
              : "0px",
        }}
        className={
          isMdaeNavigationBarExpanded
            ? "mdae-menu-item-container" +
              (props.auditsSectionMenuItemListItem.selected
                ? " selected audits-tab-section "
                : "")
            : "mdae-menu-item-container minimized" +
              (props.auditsSectionMenuItemListItem.selected
                ? " selected audits-tab-section "
                : "")
        }
        title={
          isMdaeNavigationBarExpanded ||
          props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
            props.auditsSectionMenuItemListItem
          )
            ? ""
            : props.auditsSectionMenuItemListItem.title
        }
      >
        {(isMdaeNavigationBarExpanded ||
          (!isMdaeNavigationBarExpanded &&
            !props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
              props.auditsSectionMenuItemListItem
            ))) && (
          <a
            href={props.auditsSectionMenuItemListItem.menuUrl}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              props.changePageLocation(
                props.auditsSectionMenuItemListItem.menuUrl,
                props.auditsSectionMenuItemListItem.isOpenInNewTab,
                props.auditsSectionMenuItemListItem.mdaeMenuClickHandler,
                props.auditsSectionMenuItemListItem.isReactMenu
              );
            }}
            style={{
              color: props.auditsSectionMenuItemListItem.selected
                ? "white"
                : "rgba(0, 0, 0, 0.87)",
              padding: isMdaeNavigationBarExpanded
                ? "10px 0px 10px 10px"
                : "10px 0px 10px 0px",
              textDecoration: "unset",
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className={
                "menu-icon " +
                props.auditsSectionMenuItemListItem.iconClassName +
                (props.auditsSectionMenuItemListItem.selected
                  ? " selected "
                  : "")
              }
            ></div>
          </a>
        )}

        <div className="align-items-center">
          {props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
            props.auditsSectionMenuItemListItem
          ) && (
            <div>
              <MdaeMenu
                id={""}
                items={[props.auditsSectionMenuItemListItem]}
                displayExpr={"title"}
                showFirstSubmenuMode={"onHover"}
                orientation={"vertical"}
                submenuDirection={"auto"}
                className={"sys-mdae-navigation-list-dx-menu"}
                hideSubmenuOnMouseLeave={true}
                onSubmenuShowing={(e: any) => {
                  $(e.submenu.element())
                    .find("div.dx-overlay-content.dx-menu-base")
                    .addClass("sys-mdae-navigation-list-dx-submenu-container");
                  $(
                    ".sys-mdae-navigation-list-dx-submenu-container .dx-submenu"
                  )
                    .find(".dx-menu-item")
                    .has(".menu-section-title-item")
                    .addClass("menu-section-title-item-container");
                }}
                width={isMdaeNavigationBarExpanded ? 185 : "100%"}
                height={isMdaeNavigationBarExpanded ? 20 : "100%"}
                style={{
                  marginLeft: isMdaeNavigationBarExpanded ? "10px" : "",
                }}
                itemRender={(item) => {
                  return (
                    <MdaeDrawerListItemMenuTemplate
                      mdaeMenuPanelItemSubmenuItem={item}
                      auditsSectionMenuItemListItem={
                        props.auditsSectionMenuItemListItem
                      }
                      isMdaeNavigationBarExpanded={isMdaeNavigationBarExpanded}
                      changePageLocation={props.changePageLocation}
                      mdaeNewNavigationBarConfig={{
                        hasItemAnySubmenu: (auditsSectionMenuItemListItem) => {
                          return (
                            auditsSectionMenuItemListItem.items &&
                            auditsSectionMenuItemListItem.items.length
                          );
                        },
                      }}
                    ></MdaeDrawerListItemMenuTemplate>
                  );
                }}
              ></MdaeMenu>
            </div>
          )}
          {!props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
            props.auditsSectionMenuItemListItem
          ) &&
            isMdaeNavigationBarExpanded && (
              <div className="menu-item-text">
                <a
                  href={props.auditsSectionMenuItemListItem.menuUrl}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.changePageLocation(
                      props.auditsSectionMenuItemListItem.menuUrl,
                      props.auditsSectionMenuItemListItem.isOpenInNewTab,
                      props.auditsSectionMenuItemListItem.mdaeMenuClickHandler,
                      props.auditsSectionMenuItemListItem.isReactMenu
                    );
                  }}
                  style={{
                    padding: "10px 10px 10px 0px",
                    textDecoration: "unset",
                    height: "100%",
                    width: "auto",
                    display: "flex",
                    alignItems: "center",
                    color: props.auditsSectionMenuItemListItem.selected
                      ? "white"
                      : "rgba(0, 0, 0, 0.87)",
                  }}
                >
                  {props.auditsSectionMenuItemListItem.title + " "}
                  {props.auditsSectionMenuItemListItem?.isNewMenu === true && (
                    <sup>
                      <span className="dx-new-menu-ind">New</span>
                    </sup>
                  )}
                </a>
                {currentItemNotificationCount > 0 && (
                  <div>
                    <Notification count={currentItemNotificationCount} />
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
export default MdaeDrawerListItemTemplate;